import util from '@bmp-vue/core/api/util'
import ui from '@bmp-vue/core/api/ui'
const controller = 'Estruturadas'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  TipoOperacaoCred: [
    { value: 1, text: 'Com Garantia' },
    { value: 2, text: 'Sem Garantia' },
    { value: 3, text: 'Financiamento/Refinanciamento' }
  ],
  Produtos: [],
  TipoContrato: [
    { grupo: '1', text: 'Capital de Giro com Garantia de Imóveis', value: 'CGI' },
    { grupo: '2', text: 'Capital de Giro com Garantia de Veiculos', value: 'CGV' },
    { grupo: '3', text: 'Capital de Giro com Garantia de Recebiveis de Cartões', value: 'CGR' },
    { grupo: '3', text: 'Capital de Giro com Garantia de Duplicatas (DM)', value: 'CGD' },
    { grupo: '3', text: 'Capital de Giro com Garantia de Cotas de SPE', value: 'CGC' },
    { grupo: '4', text: 'Capital de Giro com Garantia', value: 'CCG' },
    { grupo: '4', text: 'Capital de Giro', value: 'CSG' },
    { grupo: '2', text: 'Financiamento de Veiculos', value: 'FV' },
    { grupo: '1', text: 'Financiamento de Imóveis', value: 'FI' },
    { grupo: '4', text: 'Floor Plan', value: 'FP' },
    { grupo: '4', text: 'Conta Garantida', value: 'CGG' },
    { grupo: '3', text: 'Antecipação de Recebiveis de Cartões', value: 'AR' },
    { grupo: '3', text: 'Antecipação de Duplicatas', value: 'ADD' },
    { grupo: '1', text: 'Home Equity', value: 'CCI' },
    { grupo: '2', text: 'Refinanciamento de Veiculos', value: 'RV' },
    { grupo: '2', text: 'Refinanciamento de Máquinas e Equipamentos', value: 'RME' },
    { grupo: '4', text: 'Consignado Privado', value: 'CCR' },
    { grupo: '4', text: 'Hot Money', value: 'HOT' },
    { grupo: '4', text: 'Crédito Rotativo', value: 'CR' },
    { grupo: '4', text: 'Crédito Direto ao Consumidor', value: 'CDC' },
    { grupo: '4', text: 'Crédito pessoal sem garantia', value: 'CP' },
    { grupo: '2', text: 'Crédito pessoal com garantia de veículos', value: 'CPV' },
    { grupo: '1', text: 'Crédito pessoal com garantia de imóveis', value: 'CPI' },
    { grupo: '3', text: 'Crédito pessoal com garantia de recebíveis de cartão', value: 'CPR' },
    { grupo: '3', text: 'Crédito pessoal com garantia de duplicatas', value: 'CPG' },
    { grupo: '3', text: 'Nota comercial sem garantia', value: 'NSG' },
    { grupo: '2', text: 'Nota comercial com garantia de veículos', value: 'NTC' },
    { grupo: '2', text: 'Nota comercial com garantia de máquinas', value: 'NCM' },
    { grupo: '1', text: 'Nota comercial com garantia de imóveis', value: 'NCI' },
    { grupo: '3', text: 'Nota comercial com garantia de recebíveis', value: 'NCR' },
    { grupo: '2', text: 'Crédito pessoal com garantia de máquinas e equipamentos', value: 'CPM' },
    { grupo: '2', text: 'Capital de giro com garantia de máquinas e equipamentos', value: 'CGM' },
    { grupo: '2', text: 'Capital de Giro com Garantia de Embarcação', value: 'CGE' },
    { grupo: '2', text: 'Crédito Pessoal com Garantia de Embarcação', value: 'CPE' },
    { grupo: '4', text: 'Crédito Estudantil', value: 'CES' }
  ],
  TipoAssinatura: [
    { text: 'Cartular - Documento Físico', value: 'C' },
    { text: 'Certificação Digital', value: 'D' },
    { text: 'Assinatura Eletrônica', value: 'E' }
  ],
  GetTipoOperacaoByTipoPessoa (documentoFederal, param) {
    var tipoOp = param.flatMap(p => p.TipoOperacao)
    if (ui.Format.SomenteAlfanumerico(documentoFederal).length === 11) { return ctrl.TipoOperacaoCred.filter(p => tipoOp.includes(p.value)) }
    return ctrl.TipoOperacaoCred.filter(p => tipoOp.includes(p.value));
  },
  garantiaBySigla (th) {
    const tipoPessoa = th.model.Cliente.TipoPessoa === 1 ? 'PF' : 'PJ'
    const parametro = th.$param.EST_PRODUTOS.find(p => p.TipoOperacao === th.model.TipoOperacaoCred && p.TipoPessoa === tipoPessoa).Produtos
    return parametro.find(p => p.Sigla === th.model.TipoContratoSigla)
  },
  GrupoBem: [
    { value: 1, text: 'Bens Imóveis' },
    { value: 2, text: 'Bens Móveis' },
    { value: 3, text: 'Bens Financeiros' }
  ],
  GrupoBemEnum: {
    BemImovel: 1,
    BemMovel: 2,
    BemFinanceiro: 3,
  },
  Arranjos: [
    { value: ' ', text: 'Todos' },
    { value: 'ACC', text: 'Amex Cartão de Crédito' },
    { value: 'BCC', text: 'Banescard Cartão de Crédito' },
    { value: 'BCD', text: 'Banescard Cartão de Débito' },
    { value: 'BVV', text: 'Ben Visa Vale' },
    { value: 'CAC', text: 'Cielo Amex Crédito' },
    { value: 'CBC', text: 'Cabal Crédito' },
    { value: 'CBD', text: 'Cabal Débito' },
    { value: 'CBP', text: 'Cabal Pré-Pago' },
    { value: 'CDC', text: 'Cielo Diners Cartão de Crédito' },
    { value: 'CEC', text: 'Cielo Elo Cartão de Crédito' },
    { value: 'CED', text: 'Cielo Elo Cartão de Débito' },
    { value: 'CHC', text: 'Cielo Hipercard Crédito' },
    { value: 'CMC', text: 'Cielo Mastercard Crédito' },
    { value: 'CMD', text: 'Cielo Mastercard Débito' },
    { value: 'CZC', text: 'CREDZ Crédito' },
    { value: 'DCC', text: 'Diners Cartão de Crédito' },
    { value: 'ECC', text: 'Elo Cartão de Crédito' },
    { value: 'ECD', text: 'Elo Cartão de Débito' },
    { value: 'GCC', text: 'Goodcard Crédito' },
    { value: 'GDC', text: 'Global Payments Diners Crédito' },
    { value: 'GMC', text: 'Global Payments MasterCard Crédito' },
    { value: 'GMD', text: 'Global Payments MasterCard Débito' },
    { value: 'GVC', text: 'Global Payments VISA Crédito' },
    { value: 'GVD', text: 'Global Payments VISA Débito' },
    { value: 'HCC', text: 'Hipercard Cartão de Crédito' },
    { value: 'JCC', text: 'JCB Cartão de Crédito' },
    { value: 'MAC', text: 'Mais Cartão de Crédito' },
    { value: 'MCA', text: 'MasterCard Cartão ATM' },
    { value: 'MCC', text: 'Mastercard Cartão de Crédito' },
    { value: 'MCD', text: 'Mastercard Cartão de Débito' },
    { value: 'MCP', text: 'Mastercard Cartão Pré-Pago' },
    { value: 'OCD', text: 'Ourocard Cartão de Débito' },
    { value: 'SCC', text: 'Sorocred Cartão de Crédito' },
    { value: 'SCD', text: 'Sorocred Cartão de Débito' },
    { value: 'VCA', text: 'Visa Cartão ATM' },
    { value: 'VCC', text: 'Visa Cartão de Crédito' },
    { value: 'VCD', text: 'Visa Cartão de Débito' },
    { value: 'VCP', text: 'Visa Cartão Pré-Pago' },
    { value: 'VDC', text: 'Verdecard Cartão de Crédito' },
    { value: 'VIC', text: 'Visa Internacional Compra Crédito' },
    { value: 'VID', text: 'Visa Internacional Compra Débito' }
  ],
  Credenciadoras: [
    { value: 'Todos', text: 'Todos' },
    { value: '00000208 - BRB – BANCO DE BRASÝLIA S.A', text: 'BRB – BANCO DE BRASÝLIA S.A' },
    { value: '33171211 - ACQIO ADQUIRÊNCIA S.A', text: 'ACQIO ADQUIRÊNCIA S.A' },
    { value: '14796606 - ADYEN DO BRASIL LTDA', text: 'ADYEN DO BRASIL LTDA' },
    { value: '13776742 - AGILITAS SOLUÇÕES DE PAGAMENTOS LTDA', text: 'AGILITAS SOLUÇÕES DE PAGAMENTOS LTDA' },
    { value: '20520298 - BANCO BONSUCESSO S.A. ADQUIRENTE', text: 'BANCO BONSUCESSO S.A. ADQUIRENTE' },
    { value: '31872495 - BANCO C6 S.A', text: 'BANCO C6 S.A' },
    { value: '02038232 - BANCO COOPERATIVO SICOOB S.A', text: 'BANCO COOPERATIVO SICOOB S.A ' },
    { value: '01181521 - BANCO COOPERATIVO SICREDI S.A.', text: 'BANCO COOPERATIVO SICREDI S.A.' },
    { value: '61033106 - BANCO CREFISA S.A', text: 'BANCO CREFISA S.A' },
    { value: '58497702 - BANCO LETSBANK S.A.', text: 'BANCO LETSBANK S.A.' },
    { value: '68900810 - BANCO RENDIMENTO S.A.', text: 'BANCO RENDIMENTO S.A.' },
    { value: '58160789 - BANCO SAFRA S.A.', text: 'BANCO SAFRA S.A.' },
    { value: '04814563 - BANCO SOROCRED S.A - BANCO MULTIPLO', text: 'BANCO SOROCRED S.A - BANCO MULTIPLO' },
    { value: '17351180 - BANCO TRIÂNGULO S.A.', text: 'BANCO TRIÂNGULO S.A.' },
    { value: '28127603 - BANESTES S.A. - BANCO DO ESTADO DO ESPÝRITO SANTO', text: 'BANESTES S.A. - BANCO DO ESTADO DO ESPÝRITO SANTO' },
    { value: '92934215 - BANRISUL CARTÕES S.A.', text: 'BANRISUL CARTÕES S.A.' },
    { value: '20551972 - BEBLUE SOLUÇÕES DE CASHBACK, SERVIÇOS PROMOCIONAIS E MEIOS DE PAGAMENTOS S.A', text: 'BEBLUE SOLUÇÕES DE CASHBACK, SERVIÇOS PROMOCIONAIS E MEIOS DE PAGAMENTOS S.A' },
    { value: '30798783 - BEN BENEFÝCIOS E SERVIÇOS S.A.', text: 'BEN BENEFÝCIOS E SERVIÇOS S.A.' },
    { value: '28080769 - BOLT CARD CREDENCIADORA DE CARTAO DE CREDITO LTDA', text: 'BOLT CARD CREDENCIADORA DE CARTAO DE CREDITO LTDA' },
    { value: '35542555 - CARDPAY BRASIL SERVICOS DE INTERNET LTDA', text: 'CARDPAY BRASIL SERVICOS DE INTERNET LTDA' },
    { value: '13207930 - CHECKOUT DO BRASIL LTDA', text: 'CHECKOUT DO BRASIL LTDA' },
    { value: '01027058 - CIELO S.A.', text: 'CIELO S.A.' },
    { value: '18189547 - CLOUDWALK MEIOS DE PAGAMENTOS E SERVICOS LTDA', text: 'CLOUDWALK MEIOS DE PAGAMENTOS E SERVICOS LTDA ' },
    { value: '01425787 - CREDICARD', text: 'CREDICARD' },
    { value: '17803384 - DIAMANTE SERVIÇOS DIGITAIS LTDA', text: 'DIAMANTE SERVIÇOS DIGITAIS LTDA' },
    { value: '08744817 - DOCK SOLUCOES EM MEIOS DE PAGAMENTO S A', text: 'DOCK SOLUCOES EM MEIOS DE PAGAMENTO S A' },
    { value: '24080493 - EBANX PAGAMENTOS LTDA', text: 'EBANX PAGAMENTOS LTDA ' },
    { value: '59158642 - EDENRED SOLUÇÕES DE PAGAMENTOS HYLA S.A', text: 'EDENRED SOLUÇÕES DE PAGAMENTOS HYLA S.A' },
    { value: '12592831 - ELAVON DO BRASIL SA', text: 'ELAVON DO BRASIL SA' },
    { value: '52556578 - ELGIN S.A', text: 'ELGIN S.A' },
    { value: '09227084 - ELO SERVIÇOS S.A', text: 'ELO SERVIÇOS S.A' },
    { value: '10506341 - ENOPP SERVIÇOS DE GESTÃO DE NEGÓCIOS E PROJETOS LTDA', text: 'ENOPP SERVIÇOS DE GESTÃO DE NEGÓCIOS E PROJETOS LTDA' },
    { value: '17768068 - ESMERALDA SERVIÇOS DIGITAIS LTDA', text: 'ESMERALDA SERVIÇOS DIGITAIS LTDA' },
    { value: '04556068 - EVOLUSERVICES MEIOS DE PAGAMENTO LTDA - EPP', text: 'EVOLUSERVICES MEIOS DE PAGAMENTO LTDA - EPP' },
    { value: '00714671 - EWALLY TECNOLOGIA E SERVIÇOS S.A.', text: 'EWALLY TECNOLOGIA E SERVIÇOS S.A.' },
    { value: '04962772 - FD DO BRASIL SOLUÇÕES DE PAGAMENTO LTDA', text: 'FD DO BRASIL SOLUÇÕES DE PAGAMENTO LTDA' },
    { value: '10440482 - GETNET ADQUIRENCIA E SERVIÇOS PARA MEIOS DE PAGAMENTO S.A.', text: 'GETNET ADQUIRENCIA E SERVIÇOS PARA MEIOS DE PAGAMENTO S.A.' },
    { value: '17887874 - GLOBALPAYMENTS SERVIÇOS DE PAGAMENTOS S.A', text: 'GLOBALPAYMENTS SERVIÇOS DE PAGAMENTOS S.A' },
    { value: '22177858 - GRANITO SOLUÇÕES EM PAGAMENTO S.A', text: 'GRANITO SOLUÇÕES EM PAGAMENTO S.A' },
    { value: '06308851 - HAGANÝ FOMENTO MERCANTIL LTDA', text: 'HAGANÝ FOMENTO MERCANTIL LTDA' },
    { value: '13884775 - HUB PAGAMENTOS S.A.', text: 'HUB PAGAMENTOS S.A.' },
    { value: '14380200 - IFOOD.COM AGÊNCIA DE RESTAURANTES ONLINE S.A.', text: 'IFOOD.COM AGÊNCIA DE RESTAURANTES ONLINE S.A.' },
    { value: '17344776 - IZETTLE DO BRASIL MEIOS DE PAGAMENTO LTDA', text: 'IZETTLE DO BRASIL MEIOS DE PAGAMENTO LTDA' },
    { value: '13427325 - LAUNCH PAD TECNOLOGIA E SERVIÇOS LTDA', text: 'LAUNCH PAD TECNOLOGIA E SERVIÇOS LTDA' },
    { value: '32971064 - LISTO INSTITUIÇÃO DE PAGAMENTO LTDA', text: 'LISTO INSTITUIÇÃO DE PAGAMENTO LTDA' },
    { value: '09614276 - M4 PRODUTOS E SERVIÇOS S.A.', text: 'M4 PRODUTOS E SERVIÇOS S.A.' },
    { value: '08508546 - MAXICARD CONSULTORIA DE NEGOCIOS EM TECNOLOGIA LTDA', text: 'MAXICARD CONSULTORIA DE NEGOCIOS EM TECNOLOGIA LTDA' },
    { value: '10573521 - MERCADOPAGO.COM REPRESENTACOES LTDA.', text: 'MERCADOPAGO.COM REPRESENTACOES LTDA.' },
    { value: '23612423 - PAG.AI TECNOLOGIA E INOVAÇÃO SA', text: 'PAG.AI TECNOLOGIA E INOVAÇÃO SA' },
    { value: '08561701 - PAGSEGURO INTERNET S.A.', text: 'PAGSEGURO INTERNET S.A.  ' },
    { value: '15673592 - PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA', text: 'PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA' },
    { value: '22896431 - PICPAY SERVIÇOS S.A.', text: 'PICPAY SERVIÇOS S.A.' },
    { value: '17079937 - PINBANK BRASIL - PAGAMENTOS INTELIGENTES S.A', text: 'PINBANK BRASIL - PAGAMENTOS INTELIGENTES S.A' },
    { value: '18191228 - PJBANK PAGAMENTOS S.A.', text: 'PJBANK PAGAMENTOS S.A. ' },
    { value: '17829537 - PLANET PAYMENT DO BRASIL SERVICOS DE TECNOLOGIA DE INFORMACOES LTDA', text: 'PLANET PAYMENT DO BRASIL SERVICOS DE TECNOLOGIA DE INFORMACOES LTDA' },
    { value: '01722480 - QUERO-QUERO VERDECARD INSTITUIÇÃO DE PAGAMENTO S.A', text: 'QUERO-QUERO VERDECARD INSTITUIÇÃO DE PAGAMENTO S.A' },
    { value: '01425787 - REDECARD S.A.', text: 'REDECARD S.A.' },
    { value: '14233366 - RP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.', text: 'RP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.' },
    { value: '17803403 - SAFIRA SERVIÇOS DIGITAIS LTDA', text: 'SAFIRA SERVIÇOS DIGITAIS LTDA' },
    { value: '12901364 - SAQUE E PAGUE REDE DE AUTOATENDIMENTO', text: 'SAQUE E PAGUE REDE DE AUTOATENDIMENTO' },
    { value: '03847413 - SEAC - SERGIPE ADMINISTRADORA DE CARTOES E SERVICOS LTDA', text: 'SEAC - SERGIPE ADMINISTRADORA DE CARTOES E SERVICOS LTDA' },
    { value: '29759316 - SERVNET ADMINISTRACAO DE CARTOES LTDA ', text: 'SERVNET ADMINISTRACAO DE CARTOES LTDA ' },
    { value: '03766873 - SICOOB SOLUÇÕES DE PAGAMENTO LTDA', text: 'SICOOB SOLUÇÕES DE PAGAMENTO LTDA' },
    { value: '13207930 - SLED S.A.', text: 'SLED S.A.' },
    { value: '60114865 - SOROCRED MEIOS DE PAGAMENTO', text: 'SOROCRED MEIOS DE PAGAMENTO' },
    { value: '14625224 - STELO S.A', text: 'STELO S.A' },
    { value: '16501555 - STONE PAGAMENTOS S.A.', text: 'STONE PAGAMENTOS S.A.' },
    { value: '22121209 - STRIPE BRASIL SOLUÇÕES DE PAGAMENTO LTDA', text: 'STRIPE BRASIL SOLUÇÕES DE PAGAMENTO LTDA' },
    { value: '16668076 - SUMUP SOLUÇÕES DE PAGAMENTO BRASIL LTDA', text: 'SUMUP SOLUÇÕES DE PAGAMENTO BRASIL LTDA' },
    { value: '08718431 - WIRECARD BRASIL S.A.', text: 'WIRECARD BRASIL S.A.' },
    { value: '00991143 - WORLDPAY DO BRASIL PROCESSAMENTO DE PAGAMENTOS LTDA', text: 'WORLDPAY DO BRASIL PROCESSAMENTO DE PAGAMENTOS LTDA' }
  ],
  Subcredenciadoras: [
    { value: 'Todos', text: 'Todos' },
    { value: '00714671 - EWALLY TECNOLOGIA E SERVIÇOS S.A.', text: 'EWALLY TECNOLOGIA E SERVIÇOS S.A.' },
    { value: '18033552 - 99 TECNOLOGIA LTDA', text: '99 TECNOLOGIA LTDA' },
    { value: '18928397 - ADIQPLUS INSTITUICAO DE PAGAMENTO LTDA', text: 'ADIQPLUS INSTITUICAO DE PAGAMENTO LTDA' },
    { value: '14796606 - ADYEN DO BRASIL LTDA', text: 'ADYEN DO BRASIL LTDA' },
    { value: '13776742 - AGILITAS SOLUÇÕES DE PAGAMENTOS LTDA', text: 'AGILITAS SOLUÇÕES DE PAGAMENTOS LTDA' },
    { value: '28494032 - ALPE INTERMEDIACAO DE NEGOCIOS S.A.', text: 'ALPE INTERMEDIACAO DE NEGOCIOS S.A. ' },
    { value: '15436940 - AMAZON SERVICOS DE VAREJO DO BRASIL LTDA.', text: 'AMAZON SERVICOS DE VAREJO DO BRASIL LTDA. ' },
    { value: '17768534 - AMETISTA SERVIÇOS DIGITAIS LTDA', text: 'AMETISTA SERVIÇOS DIGITAIS LTDA' },
    { value: '00776574 - B2W COMPANHIA DIGITAL', text: 'B2W COMPANHIA DIGITAL' },
    { value: '20551972 - BEBLUE SOLUÇÕES DE CASHBACK, SERVIÇOS PROMOCIONAIS E MEIOS DE PAGAMENTOS S.A', text: 'BEBLUE SOLUÇÕES DE CASHBACK, SERVIÇOS PROMOCIONAIS E MEIOS DE PAGAMENTOS S.A' },
    { value: '07355049 - BRASPAG - TECNOLOGIA EM PAGAMENTO LTDA', text: 'BRASPAG - TECNOLOGIA EM PAGAMENTO LTDA' },
    { value: '18189547 - CLOUDWALK MEIOS DE PAGAMENTOS E SERVICOS LTDA', text: 'CLOUDWALK MEIOS DE PAGAMENTOS E SERVICOS LTDA ' },
    { value: '18827467 - CRISTAL ADMINISTRADORA DE CARTOES DE CREDITO LTDA', text: 'CRISTAL ADMINISTRADORA DE CARTOES DE CREDITO LTDA' },
    { value: '17803384 - DIAMANTE SERVIÇOS DIGITAIS LTDA', text: 'DIAMANTE SERVIÇOS DIGITAIS LTDA' },
    { value: '25021356 - DLOCAL BRASIL PAGAMENTOS LTDA', text: 'DLOCAL BRASIL PAGAMENTOS LTDA' },
    { value: '24080493 - EBANX PAGAMENTOS LTDA ', text: 'EBANX PAGAMENTOS LTDA ' },
    { value: '59158642 - EDENRED SOLUÇÕES DE PAGAMENTOS HYLA S.A', text: 'EDENRED SOLUÇÕES DE PAGAMENTOS HYLA S.A' },
    { value: '52556578 - ELGIN S.A', text: 'ELGIN S.A' },
    { value: '10506341 - ENOPP SERVIÇOS DE GESTÃO DE NEGÓCIOS E PROJETOS LTDA', text: 'ENOPP SERVIÇOS DE GESTÃO DE NEGÓCIOS E PROJETOS LTDA' },
    { value: '18577728 - ESFERA 5 TECNOLOGIA E PAGAMENTOS S.A', text: 'ESFERA 5 TECNOLOGIA E PAGAMENTOS S.A' },
    { value: '17768068 - ESMERALDA SERVIÇOS DIGITAIS LTDA', text: 'ESMERALDA SERVIÇOS DIGITAIS LTDA' },
    { value: '04556068 - EVOLUSERVICES MEIOS DE PAGAMENTO LTDA - EPP', text: 'EVOLUSERVICES MEIOS DE PAGAMENTO LTDA - EPP' },
    { value: '09089356 - GERENCIANET S/A', text: 'GERENCIANET S/A' },
    { value: '11200418 - GFG COMERCIO DIGITAL LTDA. ', text: 'GFG COMERCIO DIGITAL LTDA. ' },
    { value: '22177858 - GRANITO SOLUÇÕES EM PAGAMENTO S.A', text: 'GRANITO SOLUÇÕES EM PAGAMENTO S.A' },
    { value: '06308851 - HAGANÝ FOMENTO MERCANTIL LTDA', text: 'HAGANÝ FOMENTO MERCANTIL LTDA' },
    { value: '14380200 - IFOOD.COM AGÊNCIA DE RESTAURANTES ONLINE S.A.', text: 'IFOOD.COM AGÊNCIA DE RESTAURANTES ONLINE S.A.' },
    { value: '17344776 - IZETTLE DO BRASIL MEIOS DE PAGAMENTO LTDA', text: 'IZETTLE DO BRASIL MEIOS DE PAGAMENTO LTDA' },
    { value: '13427325 - LAUNCH PAD TECNOLOGIA E SERVIÇOS LTDA', text: 'LAUNCH PAD TECNOLOGIA E SERVIÇOS LTDA' },
    { value: '27547510 - LINX PAY MEIOS DE PAGAMENTO LTDA', text: 'LINX PAY MEIOS DE PAGAMENTO LTDA' },
    { value: '20250105 - LISTO TECNOLOGIA S.A.', text: 'LISTO TECNOLOGIA S.A.' },
    { value: '26794946 - LUCREE SOLUCOES INTELIGENTES LTDA.', text: 'LUCREE SOLUCOES INTELIGENTES LTDA.' },
    { value: '09614276 - M4 PRODUTOS E SERVIÇOS S.A.', text: 'M4 PRODUTOS E SERVIÇOS S.A.' },
    { value: '10490181 - MADEIRAMADEIRA COMERCIO ELETRONICO S.A', text: 'MADEIRAMADEIRA COMERCIO ELETRONICO S.A' },
    { value: '17948578 - MAGALU PAGAMENTOS', text: 'MAGALU PAGAMENTOS' },
    { value: '08508546 - MAXICARD CONSULTORIA DE NEGOCIOS EM TECNOLOGIA LTDA', text: 'MAXICARD CONSULTORIA DE NEGOCIOS EM TECNOLOGIA LTDA' },
    { value: '33444505 - MR PAGAMENTOS SA', text: 'MR PAGAMENTOS SA' },
    { value: '35524559 - NATURA & CO PAY SERVIÇOS FINANCEIROS E TECNOLOGIA EM PAGAMENTOS ELETRÔNICOS LTDA', text: 'NATURA & CO PAY SERVIÇOS FINANCEIROS E TECNOLOGIA EM PAGAMENTOS ELETRÔNICOS LTDA' },
    { value: '02445579 - ONIX SERVICOS DE VALOR AGREGADO LTDA', text: 'ONIX SERVICOS DE VALOR AGREGADO LTDA' },
    { value: '18727053 - PAGAR.ME PAGAMENTOS S.A.', text: 'PAGAR.ME PAGAMENTOS S.A.' },
    { value: '21262661 - PAGOLIVRE TECNOLOGIA S.A ', text: 'PAGOLIVRE TECNOLOGIA S.A ' },
    { value: '08561701 - PAGSEGURO INTERNET S.A.', text: 'PAGSEGURO INTERNET S.A.  ' },
    { value: '03816413 - PAGUEVELOZ SERVICOS DE PAGAMENTO LTDA', text: 'PAGUEVELOZ SERVICOS DE PAGAMENTO LTDA' },
    { value: '06167186 - PAYGO ADMINISTRADORA DE MEIOS DE PAGAMENTOS LTDA', text: 'PAYGO ADMINISTRADORA DE MEIOS DE PAGAMENTOS LTDA' },
    { value: '15673592 - PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA', text: 'PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA' },
    { value: '08965639 - PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA', text: 'PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA' },
    { value: '22896431 - PICPAY SERVIÇOS S.A.', text: 'PICPAY SERVIÇOS S.A.' },
    { value: '17079937 - PINBANK BRASIL - PAGAMENTOS INTELIGENTES S.A', text: 'PINBANK BRASIL - PAGAMENTOS INTELIGENTES S.A' },
    { value: '18191228 - PJBANK PAGAMENTOS S.A.', text: 'PJBANK PAGAMENTOS S.A. ' },
    { value: '07945233 - POLOCRED - SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LTDA', text: 'POLOCRED - SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LTDA' },
    { value: '36382680 - QUERO 2 PAY SOLUÇÕES EM MEIOS DE PAGAMENTOS LTDA', text: 'QUERO 2 PAY SOLUÇÕES EM MEIOS DE PAGAMENTOS LTDA ' },
    { value: '26900161 - RAPPI BRASIL INTERMEDIACAO DE NEGOCIOS LTDA', text: 'RAPPI BRASIL INTERMEDIACAO DE NEGOCIOS LTDA' },
    { value: '25104230 - ROADPASS PAYMENTS & URBAN MOBILITY LTDA', text: 'ROADPASS PAYMENTS & URBAN MOBILITY LTDA' },
    { value: '14233366 - RP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.', text: 'RP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.' },
    { value: '17803403 - SAFIRA SERVIÇOS DIGITAIS LTDA', text: 'SAFIRA SERVIÇOS DIGITAIS LTDA' },
    { value: '03847413 - SEAC - SERGIPE ADMINISTRADORA DE CARTOES E SERVICOS LTDA', text: 'SEAC - SERGIPE ADMINISTRADORA DE CARTOES E SERVICOS LTDA' },
    { value: '14625224 - STELO S.A', text: 'STELO S.A' },
    { value: '16501555 - STONE PAGAMENTOS S.A.', text: 'STONE PAGAMENTOS S.A.' },
    { value: '22121209 - STRIPE BRASIL SOLUÇÕES DE PAGAMENTO LTDA', text: 'STRIPE BRASIL SOLUÇÕES DE PAGAMENTO LTDA' },
    { value: '16668076 - SUMUP SOLUÇÕES DE PAGAMENTO BRASIL LTDA', text: 'SUMUP SOLUÇÕES DE PAGAMENTO BRASIL LTDA' },
    { value: '17895646 - UBER DO BRASIL TECNOLOGIA LTDA.', text: 'UBER DO BRASIL TECNOLOGIA LTDA.' },
    { value: '08718431 - WIRECARD BRASIL S.A.', text: 'WIRECARD BRASIL S.A.' },
    { value: '14338304 - YAPAY PAGAMENTOS ONLINE LTDA', text: 'YAPAY PAGAMENTOS ONLINE LTDA' },
    { value: '19468242 - ZOOP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.', text: 'ZOOP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.' }
  ],
  GetProdutos (documentoFederal, tipoOperacao, params, tipoProduto) {
    var documento = ui.Format.SomenteAlfanumerico(documentoFederal)
    var tipoDocumento = documento.length === 11 ? 'PF' : 'PJ'
    var produtos = []
    produtos = ctrl.GetProdutosByPessoaOperacao(params, tipoDocumento, tipoOperacao, tipoProduto)
    return produtos
  },
  GetProdutosByPessoaOperacao (parametro, tipoPessoa, tipoOperacao, tipoProduto) {
    if (tipoOperacao) {
      const i = parametro.findIndex(el => el.TipoPessoa === tipoPessoa && el.TipoOperacao === tipoOperacao)
      if (i !== -1 && !tipoProduto) {
        return ctrl.TipoContrato.filter(p => { return parametro[i].Produtos.findIndex(j => j.Sigla === p.value) >= 0 })
      } else if (i !== -1 && tipoProduto) {
        const produtoSelecionado = parametro[i].Produtos.find(j => j.Sigla === tipoProduto)
        return produtoSelecionado ? ctrl.TipoAssinatura.filter(p => produtoSelecionado[p.value] !== null && produtoSelecionado[p.value] !== undefined) : []
      } else {
        return []
      }
    }
  },
  ModeloCalculoEnum: {
    Price: 1,
    SAC: 2
  },
  Indexador: [
    { value: 1, text: 'CDI' },
    { value: 2, text: 'SELIC' },
    { value: 3, text: 'IPCA' },
    { value: 4, text: 'PTAX' },
    { value: 5, text: 'IGP-M' },
    { value: 6, text: 'INCC' }
  ],
  TipoAssinanteEnum: {
    Emitente: 1,
    Avalista: 3,
    Conjuge: 4,
    Outros: 9
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SaveProposta (th, callback) {
    if (th.$route.query.codigoProposta || th.model.Codigo) {
      saveProposta(callback, true)
    } else {
      let valorSolicitado = th.model.TipoOperacaoCred === 3 ? (th.model.VlrProdutoBem - th.model.VlrEntrada) : th.model.VlrSolicitado
      valorSolicitado += th.model.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC ? (th.model.VlrITBI + th.model.VlrRegistroImovel) : 0
      const dto = {
        CodigoOperacao: th.model.CodigoOperacao,
        DocumentoCliente: th.model.Cliente.DocumentoFederal,
        DocumentoParceiroCorrespondente: th.$api.UI.Format.SomenteAlfanumerico(
          th.$empresa.documentoFederal
        ),
        VlrSolicitado: valorSolicitado,
        VlrEntrada: th.model.TipoOperacaoCred === 3 ? th.model.VlrEntrada : 0,
        Prazo: th.model.QtdeParcelasSolicitado,
        FormatoCalculo: 1,
        PercJurosNegociado: th.model.TipoContratoSigla === 'FI' ? ctrl.JurosAnualParaMensal(th.model.PercJurosAnual) : th.model.PercJurosMensal,
        VlrIOF: th.model.VlrIOF,
        PercIOF: th.model.PercIOF,
        QtdeParcelas: th.model.QtdeParcelasSolicitado,
        VlrParcela: th.model.VlrParcela,
        VlrTAC: th.model.VlrTAC,
        VlrBoleto: th.model.VlrBoleto,
        DtPrimeiroVencto: th.model.DtPrimeiroVencto,
        TipoIndiceFinan: th.model.TipoIndiceFinan,
        PercIndiceFinan: th.model.PercIndiceFinan,
        PropostaContaPagamentoDTO: {
          TipoConta: th.model.ContaPagamento.TipoConta === 3 ? 2 : th.model.ContaPagamento.TipoConta,
          Agencia: th.model.ContaPagamento.Agencia.split('-')[0],
          AgenciaDig: th.model.ContaPagamento.Agencia.split('-')[1],
          Conta: th.model.ContaPagamento.Conta.split('-')[0],
          ContaDig: th.model.ContaPagamento.Conta.split('-')[1],
          CodigoBanco: th.model.ContaPagamento.CodigoBanco,
          NumeroBanco: th.model.ContaPagamento.NumeroBanco
        },
        CodigoVersaoCCB: th.model.CodigoVersaoCCB,
        TipoContrato: th.model.TipoContratoSigla
      }
      if (th.model.OutrosServicos) {
        dto.VlrSeguro = (th.model.VlrSeguro || 0)
        dto.VlrAvaliacao = (th.model.VlrAvaliacao || 0)
        dto.VlrVistoria = (th.model.VlrVistoria || 0)
      }

      if (th.model.TipoOperacaoCred === 3) {
        dto.VlrProdutoBem = th.model.VlrProdutoBem
      }

      if (th.model.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC) {
        if (th.model.TipoIndexador === 2) {
          dto.TipoIndiceFinanceiro = th.model.TipoIndiceFinan
          dto.PercIndiceFinanceiro = th.model.PercIndiceFinan
        }
        dto.VlrTxAdmMensal = th.model.VlrTxAdmMensal
        dto.PercSeguroMensal1 = th.model.PercSeguroMensal1
        dto.PercSeguroMensal2 = th.model.PercSeguroMensal2
        dto.VlrSeguroMensal1 = th.model.VlrSeguroMensal1
        dto.VlrSeguroMensal2 = th.model.VlrSeguroMensal2
        dto.NroDiasAcrescimo = th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), th.model.DtPrimeiroVencto)
      }

      if (th.model.TipoDesembolso === th.$api.Enums.TipoDesembolso.Outros) {
        dto.DocumentoPromotor = th.model.Promotor.DocumentoFederal
        dto.PropostaContaPagamentoDTO = {
          ...dto.PropostaContaPagamentoDTO,
          DocumentoFederalPagamento: th.model.ContaPagamento.DocumentoFederal,
          NomePagamento: th.model.ContaPagamento.Nome,
        }
      }
      const parametros = [
        { Nome: 'SituacaoPropostaEmDigitacao', Valor: true }
      ]
      if (ctrl.isNotaComercial(th.model.TipoContratoSigla) || th.model.IsentarIOF) {
        parametros.push({ Nome: 'PROPOSTA_ISENTARIOF', Valor: true })
      }

      const isFluxoIrregular = th.model.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular
      const method = isFluxoIrregular ? 'IncluirPropostaFluxoIrregular' : th.model.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC ? 'IncluirPropostaManualSAC' : 'IncluirPropostaManual'
      let dtoFluxoIrregular = {}
      if (isFluxoIrregular) {
        dtoFluxoIrregular = {
          CodigoSimulacao: th.model.CodigoSimulacao,
          CodigoOperacao: th.model.CodigoOperacao,
          DocumentoCliente: th.model.Cliente.DocumentoFederal,
          DocumentoParceiroCorrespondente: th.$api.UI.Format.SomenteAlfanumerico(
            th.$empresa.documentoFederal
          ),
          PropostaContaPagamentoDTO: { ...dto.PropostaContaPagamentoDTO }
        }
      }
      const obj = isFluxoIrregular ? { dto: dtoFluxoIrregular } : { dto, parametros }
      th.$api.Multiplo.Post(method, obj).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$set(th.value, 'Codigo', response.Codigo)
          th.$api.Multiplo.FindRecordProposta({ guidID: response.Codigo }).then(function (proposta) {
            if (th.$api.UI.PostLoadData(proposta)) {
              proposta.Cliente = Object.assign(th.model.Cliente, proposta.Cliente)
              th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', proposta)
              th.$set(th.value, 'CodigoCliente', proposta.CodigoCliente)
              saveProposta(callback)
            }
          })
        }
      })
    }
    function saveProposta (callback, atualizarContaPagamento) {
      const dtoSave = th.model
      dtoSave.DocumentoParceiroCorrespondente = th.$api.UI.Format.SomenteAlfanumerico(
        th.$empresa.documentoFederal
      )
      dtoSave.CodigoVersaoCCB = th.model.CodigoVersaoCCB
      dtoSave.TipoContrato = th.model.TipoContratoSigla
      dtoSave.UsarJurosProposta = true
      dtoSave.CodigoPromotor = null
      dtoSave.ByPassSituacaoOnSave = true
      dtoSave.PropostaValorSobreposto = {
        VlrTAC: th.model.VlrTAC,
        VlrAvaliacao: th.model.VlrAvaliacao,
        VlrIOF: (th.model.IsentarIOF || ctrl.isNotaComercial(th.model.TipoContratoSigla)) ? 0.001 : th.model.VlrIOF
      }
      if (th.model.TipoDesembolso === th.$api.Enums.TipoDesembolso.Outros) {
        dtoSave.CodigoPromotor = th.model.Promotor.Codigo
      }
      if (th.model.TipoContratoSigla === 'FI') {
        dtoSave.PercJurosMensal = ctrl.JurosAnualParaMensal(th.model.PercJurosAnual)
      }
      th.$api.Multiplo.SaveProposta({ dto: dtoSave }).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          ctrl.SavePropostaCampoAuxiliar(th)
          if (atualizarContaPagamento) { ctrl.SavePropostaContaPagamento(th, callback) } else { if (callback) callback() }
        }
      })
    }
  },
  SavePropostaContaPagamento (th, callback) {
    const dto = {
      dto: {
        CodigoProposta: th.model.Codigo
      },
      dtoPagto: {
        TipoConta: th.model.ContaPagamento.TipoConta === 3 ? 2 : th.model.ContaPagamento.TipoConta,
        Agencia: th.model.ContaPagamento.Agencia.split('-')[0],
        AgenciaDig: th.model.ContaPagamento.Agencia.split('-')[1],
        Conta: th.model.ContaPagamento.Conta.split('-')[0],
        ContaDig: th.model.ContaPagamento.Conta.split('-')[1],
        CodigoBanco: th.model.ContaPagamento.CodigoBanco,
        NumeroBanco: th.model.ContaPagamento.NumeroBanco
      }
    }

    if (th.model.TipoDesembolso === th.$api.Enums.TipoDesembolso.Outros) {
      dto.dtoPagto = {
        ...dto.dtoPagto,
        DocumentoFederalPagamento: th.model.ContaPagamento.DocumentoFederal,
        NomePagamento: th.model.ContaPagamento.Nome,
      }
    }
    th.$api.Multiplo.PropostaAtualizarContaPagamentoEmDigitacao(dto).then(function (response) {
      if (th.$api.UI.PostLoadData(response, true)) {
        if (callback) callback()
      }
    })
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.TipoOperacaoCred) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOOPERACAO', ValorCampo: th.model.TipoOperacaoCred }) }
    if ([null, undefined].indexOf(th.model.TipoOperacaoNome) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOOPERACAODESCRICAO', ValorCampo: th.model.TipoOperacaoNome }) }
    // if ([null, undefined].indexOf(th.model.TipoProduto) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOPRODUTO', ValorCampo: th.model.TipoProduto }) }
    if ([null, undefined].indexOf(th.model.TipoIndexador) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOINDEXADOR', ValorCampo: th.model.TipoIndexador }) }
    if ([null, undefined].indexOf(th.model.TipoCCB) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPOCCB', ValorCampo: th.model.TipoCCB }) }
    if ([null, undefined].indexOf(th.model.TipoDesembolso) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_TIPODESEMBOLSO', ValorCampo: th.model.TipoDesembolso }) }
    if (th.model.ContaPagamento.TipoConta === 3) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'CONTA_PAGAMENTO', ValorCampo: true }) }
    if (th.model.TipoDesembolso === th.$api.Enums.TipoDesembolso.Outros && th.model.Identificador) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'OUTROS_IDENTIFICADOR', ValorCampo: th.model.Identificador }) }
    if (th.model.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC) {
      campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'TIPO_IMOVEL', ValorCampo: th.model.TipoImovel })
      campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'DIVISAO_NEGOCIO', ValorCampo: th.model.DivisaoNegocio })
      var dto = {
        dto: { CodigoProposta: th.model.Codigo },
        campoExtra: {
          CampoExtra1: th.$api.UI.Format.Currency(th.model.VlrITBI).replace('R$', '').trim(),
          CampoExtra2: th.$api.UI.Format.Currency(th.model.VlrRegistroImovel).replace('R$', '').trim(),
          CampoExtra3: th.$api.UI.Format.Currency(th.model.VlrRegistroGarantia).replace('R$', '').trim()
        }
      }
      th.$api.Multiplo.PropostaAtualizarCampoExtra(dto)
    }

    if (campos.length > 0) { th.$api.Multiplo.SavePropostaCampoAuxiliar({ dto: campos }) }
  },
  ListPropostaCampoAuxiliar (th, codigoProposta) {
    const dto = { parameters: [{ name: 'CodigoProposta', value: codigoProposta }] }

    th.$api.Multiplo.ListPropostaCampoAuxiliar(dto).then(response => {
      if (th.$api.UI.PostLoadData(response, true)) {
        if (response.Data && response.Data.length > 0) {
          th.$api.Multiplo.FindPropostaCampoExtra({ guidID: codigoProposta }).then((camposExtras) => {
            if (th.$api.UI.PostLoadData(camposExtras, true)) {
              if (camposExtras.CampoAuxiliar1) { th.$set(th.model, 'VlrITBI', this.CurrencyToNumber(camposExtras.CampoAuxiliar1)) }
              if (camposExtras.CampoAuxiliar2) { th.$set(th.model, 'VlrRegistroImovel', this.CurrencyToNumber(camposExtras.CampoAuxiliar2)) }
              if (camposExtras.CampoAuxiliar3) { th.$set(th.model, 'VlrRegistroGarantia', this.CurrencyToNumber(camposExtras.CampoAuxiliar3)) }
              response.Data.forEach(item => {
                if (item.NomeCampo === 'PROPOSTA_TIPOOPERACAO') { th.$set(th.model, 'TipoOperacaoCred', parseInt(item.ValorCampo)) }
                if (item.NomeCampo === 'PROPOSTA_TIPOOPERACAODESCRICAO') { th.$set(th.model, 'TipoOperacaoNome', item.ValorCampo) }
                // if (item.NomeCampo === 'PROPOSTA_TIPOPRODUTO') { th.$set(th.model, 'TipoProduto', parseInt(item.ValorCampo)) }
                if (item.NomeCampo === 'PROPOSTA_TIPOINDEXADOR') { th.$set(th.model, 'TipoIndexador', parseInt(item.ValorCampo)) }
                if (item.NomeCampo === 'PROPOSTA_TIPOCCB') { th.$set(th.model, 'TipoCCB', item.ValorCampo) }
                if (item.NomeCampo === 'PROPOSTA_TIPODESEMBOLSO') { th.$set(th.model, 'TipoDesembolso', item.ValorCampo) }
                if (item.NomeCampo === 'DADOS_DO_SUBSCRITOR') { th.$set(th.model, 'Subscritor', JSON.parse(item.ValorCampo)) }
                if (item.NomeCampo === 'TIPO_IMOVEL') { th.$set(th.model, 'TipoImovel', item.ValorCampo) }
                if (item.NomeCampo === 'DIVISAO_NEGOCIO') { th.$set(th.model, 'DivisaoNegocio', item.ValorCampo) }
                if (item.NomeCampo === 'PROPOSTA_ISENTARIOF') { th.$set(th.model, 'IsentarIOF', item.ValorCampo) }
                if (item.NomeCampo === 'OUTROS_IDENTIFICADOR') { th.$set(th.model, 'Identificador', item.ValorCampo) }
              })
            }
          })
        }
      }
    })

    if (th.model.VlrSeguro || th.model.VlrAvaliacao || th.model.VlrVistoria) {
      th.$set(th.model, 'OutrosServicos', true)
    }
  },
  CurrencyToNumber (valorCampo) {
    try {
      let valorLimpo = valorCampo.replace('R$', '').trim();
      valorLimpo = valorLimpo.replace('.', '').replace(',', '.');
      const numero = parseFloat(valorLimpo);
      return numero;
    } catch {
      return 0
    }
  },
  labelsCSVExcel: [
    'Período',
    'Dados da Operação',
    'Coobrigação Assumida',
    'Coobrigação Recebida',
    '% Doctos Processados',
    '% Volume Processado',
    'Qtde Operações Discordância',
    'Vlr Operações Discordância',
    'Qtde Operações Sub Judice',
    'Vlr Operações Sub Judice',
    'Qtde Instituições',
    'Qtde Operações',
    'Risco Indireto Vendor',
    'Carteira a Vencer',
    'De 14 a 30 dias',
    'De 31 a 60 dias',
    'De 61 a 90 dias',
    'De 91 a 180 dias',
    'De 181 a 360 dias',
    'Mais de 360 dias',
    'Prazo Indeterminado',
    'Vencidos',
    'De 15 a 30 dias',
    'De 31 a 60 dias',
    'De 61 a 90 dias',
    'De 91 a 180 dias',
    'De 181 a 360 dias',
    'Mais de 360 dias',
    'Prejuízo',
    'Até 12 meses',
    'Acima 12 meses',
    'Limite de Crédito',
    'Até 360 dias',
    'Acima de 360 dias',
    'Carteira de Crédito',
    'Repasses',
    'Coobrigações',
    'Responsabilidade Total',
    'Créditos a Liberar',
    'Risco Indireto Vendor',
    'Risco Total',
    'Moeda Estrangeira - De 15 a 30 dias',
    'Moeda Estrangeira - De 31 a 60 dias',
    'Moeda Estrangeira - De 61 a 90 dias',
    'Moeda Estrangeira - De 91 a 180 dias',
    'Moeda Estrangeira - De 181 a 360 dias',
    'Moeda Estrangeira - Acima de 360 dias',
    'Modalidades'
  ],
  GetVlrMinTAC (th, tipoOperacaoCred, vlrProdutoBem, vlrEntrada, vlrSolicitado) {
    let valor = 0
    if (!th.$param.EST_VALORES || !th.$param.EST_VALORES.TAC) { return }

    const tac = th.$param.EST_VALORES.TAC
    const solicitado = (tipoOperacaoCred === 3 ? vlrProdutoBem - vlrEntrada : vlrSolicitado)

    valor = th.$api.UI.Parse.Decimal((((tac.Perc || 0) / 100) * solicitado).toFixed(2))
    if (valor < tac.VlrMin) { valor = tac.VlrMin }
    return valor
  },
  GetValorRegistro: async function (th, model) {
    if (!th.$param.EST_VALORES || !th.$param.EST_VALORES.Registro || th.$param.EST_VALORES.length === 0) { return }
    const registros = th.$param.EST_VALORES.Registro
    var vlrRegistro = 0
    const dto = { parameters: [{ name: 'CodigoProposta', value: model.Codigo }] }
    th.$set(model, 'VlrRegistro', 0)
    var response = await th.$api.Multiplo.ListPropostaGarantiaBem(dto)
    if (th.$api.UI.PostLoadData(response)) {
      var tipoPessoa = ui.Format.SomenteAlfanumerico(model.Cliente.DocumentoFederal).length === 11 ? 1 : 2
      for (var i = 0; i < response.Data.length; i++) {
        vlrRegistro += await this.GetValorRegistroGarantia(th, response.Data[i], tipoPessoa, registros)
      }
      th.$set(model, 'VlrRegistro', vlrRegistro)
    }
  },
  GetValorRegistroGarantia: async function (th, garantia, tipoPessoa, registros) {
    let vlrRegistro = 0

    const item = registros.find(p => p.Grupo === garantia.Grupo && p.Subgrupo === garantia.Subgrupo)
    if (item && ((item.PF && tipoPessoa === 1) || (item.PJ && tipoPessoa === 2))) {
      vlrRegistro += item.Valor || 0

      if (item.IndicadorGravame) {
        vlrRegistro += await getValorGravame()
      }
    }

    return ui.Parse.Decimal(vlrRegistro.toFixed(2))

    async function getValorGravame () {
      let valor = 0
      if (listaGravame && listaGravame.length > 0) {
        if (garantia && garantia.Grupo === 2 && garantia.Subgrupo === 1) {
          const dto = {
            guidID: garantia.Codigo
          }
          var response = garantia
          if (!response.PropostaGarantiaBemVeiculo) { response = await th.$api.Multiplo.FindRecordPropostaGarantiaBem(dto) }
          if (th.$api.UI.PostLoadData(response) && response.PropostaGarantiaBemVeiculo) {
            garantia = response
            const gravame = listaGravame.find(p => p.uf === garantia.PropostaGarantiaBemVeiculo.UFLicenciamento)
            if (gravame) {
              switch (garantia.PropostaGarantiaBemVeiculo.TipoPlaca) {
                case 1:
                case 5:
                  valor += gravame.valorTipo1
                  break
                case 2:
                  valor += gravame.valorTipo2
                  break
                case 3:
                case 4:
                case 6:
                  valor += gravame.valorTipo3
                  break
              }
            }
          }
        }
      } else {
        var gravames = await th.$api.Kraken.GetAllGravames()
        if (th.$api.UI.PostLoadData(gravames)) {
          listaGravame = gravames
          return await getValorGravame(garantia)
        }
      }

      return valor
    }
  },
  listPapeis (th, tipoAssinante, model, proposta, documento, listDocFederalGarantia) {
    var list = th.$param.EST_PAPEIS.filter((p) => p.tipo === tipoAssinante)

    list = list.filter((p) => {
      if (proposta.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PF && p.pf) {
        return true
      } else if (proposta.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PJ && p.pj) {
        return true
      }
      return false
    })
    list = list.map((p) => { return { text: p.papel, value: p.papel } })
    if (model && model.length > 0) {
      model.forEach((p) => {
        var i = list.findIndex((j) => j.value === p.text)
        if (i >= 0) {
          p.value = p.text
          list[i] = p
        } else {
          list.push(p)
        }
      })
    }

    if (listDocFederalGarantia &&
      !listDocFederalGarantia.includes(documento) &&
      list.findIndex(({ text }) => text === 'TERCEIRO GARANTIDOR') > 0
    ) {
      const i = list.findIndex(({ text }) => text === 'TERCEIRO GARANTIDOR')
      list.splice(i, 1)
    }

    return list.filter(item => item)
  },
  bureaus: [
    { value: 'ALLCHECK', text: 'ALL CHECK' },
    { value: 'ASSERTIVA', text: 'ASSERTIVA' },
    { value: 'BMPCRED', text: 'BMPCRED' },
    { value: 'DIRECTDATA', text: 'DIRECTDATA' },
    { value: 'DATABUSCA', text: 'DATA BUSCA' },
    { value: 'EMAILAGE', text: 'EMAILAGE' },
    { value: 'SCR', text: 'SCR BACEN' },
    { value: 'SERASA', text: 'SERASA' },
    { value: 'SPCBRASIL', text: 'SPC BRASIL' },
  ],
  NotasComerciais: ['NTC', 'NSG', 'NCI', 'NCM', 'NCR'],
  GarantiaVeiculo: ['CPV', 'CGV', 'NTC'],
  isNotaComercial (tipoContratoSigla) {
    return ctrl.NotasComerciais.includes(tipoContratoSigla)
  },
  RoundNotaComercial (th, callback, simulacao) {
    const isFluxoIrregular = th.model.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular
    th.$nextTick(async () => {
      const dif = (1 - (th.model.VlrTotalCredito % 1))
      if (isFluxoIrregular) {
        const tacCalculada = th.model.dtoFluxoIrregular.VlrTcCorban + dif
        th.model.dtoFluxoIrregular.VlrTcCorban = Math.round(tacCalculada * 100) / 100
      } else {
        th.model.VlrTAC += dif
      }
      th.model.VlrTAC = Math.round(th.model.VlrTAC * 100) / 100
      if (!isFluxoIrregular && !simulacao) {
        ctrl.SaveProposta(th, callback)
      } else if (isFluxoIrregular) {
        const method = !simulacao ? 'AtualizarCalculoFluxoIrregular' : 'CalcularFluxoIrregular'
        const { PMTIrregular } = await ctrl[method](th, th.model.dtoFluxoIrregular)
        th.$set(th.model, 'VlrTAC', PMTIrregular.VlrTAC)
      } else {
        if (callback) callback()
      }
    })
  },
  async CalcularFluxoIrregular (th, dto) {
    dto.VlrSolicitado = th.value.TipoOperacaoCred === 3 ? (th.value.VlrProdutoBem - th.value.VlrEntrada) : th.value.VlrSolicitado
    dto.TipoIndiceFinan = th.value.TipoIndiceFinan
    dto.PercIndiceFinan = th.value.PercIndiceFinan
    if (th.value.TipoOperacaoCred === 3) {
      dto.VlrEntrada = th.value.VlrEntrada
    }

    const response = await th.$api.Multiplo.CalcularFluxoIrregular({ dto: dto })
    if (th.$api.UI.PostLoadData(response, true)) {
      return response
    }
  },
  async AtualizarCalculoFluxoIrregular (th, dto) {
    dto.CodigoProposta = th.value.Codigo
    dto.VlrSolicitado = th.value.TipoOperacaoCred === 3 ? (th.value.VlrProdutoBem - th.value.VlrEntrada) : th.value.VlrSolicitado
    dto.TipoIndiceFinan = th.value.TipoIndiceFinan
    dto.PercIndiceFinan = th.value.PercIndiceFinan
    if (th.value.TipoOperacaoCred === 3) {
      dto.VlrEntrada = th.value.VlrEntrada
    }
    const response = await th.$api.Multiplo.AtualizarCalculoFluxoIrregular({ dto: dto })
    if (th.$api.UI.PostLoadData(response, true)) {
      return response
    }
  },
  async AtualizarDadosPropostaFluxoIrregular (th) {
    const dto = {
      CodigoProposta: th.value.Codigo,
      CodigoVersaoCCB: th.value.CodigoVersaoCCB,
      TipoIndiceFinan: th.value.TipoIndiceFinan,
      PercIndiceFinan: th.value.PercIndiceFinan,
      TipoContrato: th.value.TipoContratoSigla,
    }
    const response = await th.$api.Multiplo.AtualizarDadosPropostaFluxoIrregular({ dto: dto })
    if (th.$api.UI.PostLoadData(response, true)) {
      return response
    }
  },
  JurosAnualParaMensal (jurosAnual) {
    const baseCalculo = 1 + (jurosAnual / 100);
    const resultado = Math.pow(baseCalculo, 1 / 12) - 1;
    return parseFloat((resultado * 100).toFixed(8));
  }
})
let listaGravame = []
export default ctrl
